<template>
  <div id="DeliveryNotDefined">
    <button @click="$router.push(status.template.route)">
      <span>
        {{ status.template.down }}
      </span>
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DeliveryNotDefined',
  computed: {
    ...mapGetters('delivery', {
      status: 'getStatus'
    }),
  }
}
</script>
